const dashboardIconUrl = require('./dashboard.svg')
const businessesIconUrl = require('./businesses.svg')
const shortTermRentalsIconUrl = require('./short-term-rentals.svg')
const cryptoIconUrl = require('./crypto.svg')
const influencersIconUrl = require('./influencers.svg')
const ecommerceIconUrl = require('./ecommerce.svg')
const ecommerceExtendedIconUrl = require('./ecommerce-extended.svg')
const freelancersIconUrl = require('./freelancers.svg')
const offshoreIconUrl = require('./offshore.svg')
const dataScienceIconUrl = require('./data-science.svg')
const companyOverviewIconUrl = require('./company-overview.svg')
const fatcaIconUrl = require('./fatca.svg')
const serviceProviderIconUrl = require('./service-provider.svg')
const managementIconUrl = require('./management.svg')

export default {
  dashboardIconUrl,
  businessesIconUrl,
  shortTermRentalsIconUrl,
  cryptoIconUrl,
  influencersIconUrl,
  ecommerceIconUrl,
  ecommerceExtendedIconUrl,
  freelancersIconUrl,
  offshoreIconUrl,
  dataScienceIconUrl,
  companyOverviewIconUrl,
  fatcaIconUrl,
  serviceProviderIconUrl,
  managementIconUrl,
}
